import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';
import { hideRtkModal } from 'actions/rtks/reasonToKnowModal';

export const SAVE_CIC_REVIEW_STATE_REQUEST = 'SAVE_CIC_REVIEW_STATE_REQUEST';
export const SAVE_CIC_REVIEW_STATE_SUCCESS = 'SAVE_CIC_REVIEW_STATE_SUCCESS';
export const SAVE_CIC_REVIEW_STATE_FAILURE = 'SAVE_CIC_REVIEW_STATE_FAILURE';

function requestSaveCicReviewState() {
  return {
    type: SAVE_CIC_REVIEW_STATE_REQUEST,
    isSavingCicReviewState: true,
  };
}

function receiveSaveCicReviewState(cicReviewState) {
  return {
    type: SAVE_CIC_REVIEW_STATE_SUCCESS,
    isSavingCicReviewState: false,
    cicReviewState,
    cicReviewStateError: null
  };
}

function rejectSaveCicReviewState(cicReviewStateError) {
  return {
    type: SAVE_CIC_REVIEW_STATE_FAILURE,
    isSavingCicReviewState: false,
    cicReviewStateError
  };
}

export function saveCicReviewState(id, values) {
  const formData = new FormData();
  formData.append('reviewerComment', values.draftComments);
  formData.append('actionId', values.actionId);
  if (values.assignToUser) {
    formData.append('assignToUser', values.assignToUser.id);
  }
  if (values.isCic != null) {
    formData.append('isCic', values.isCic);
  }
  if (values.changes) {
    formData.append('changes', JSON.stringify(values.changes));
  }

  return (dispatch) => {
    dispatch(requestSaveCicReviewState());

    const promise = () => ApiService
      .saveCicReviewState(id, formData)
      .then((response) => {
        dispatch(receiveSaveCicReviewState(response.data));

        if (values.actionId || values.assignToUser) {
          // Redirect back to grid if a workflow action has been submitted
          dispatch(hideRtkModal());
        }
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }

        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, rejectSaveCicReviewState, true));
        }
      });
    return promise();
  };
}
